import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { Button } from "../../../../ui/Button";
import { useAppStore } from "../../../../stores/RootStore";
import { useNavigate } from "react-router-dom";
import ErrorsBlock from "../../../../components/errors/ErrorsBlock";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
};

const DeletePosition = ({ id, isDeleteOpen, closeModal }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/directories/posts/${id}`
  );

  const setPosts = useAppStore((store) => store.setPosts);
  const posts = useAppStore((store) => store.posts);

  const deleteType = () => {
    setPosts(posts?.filter((post) => post.id != id)!);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (deleteResponse) {
      deleteType();
      navigate("..", { relative: "path" });
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить должность</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить должность?</AlertDialogDescription>
        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeletePosition;
